import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

function GiftMessage() {
  return (
        <div className={styles.container}>
             <Text color={colors.gray6}>
                 이것은 메시지의 예시이다 Lorem ipsum dolor sit amet consectetur. Suspendisse sed morbi felis morbi venenatis a nunc mattis lobortis. Nam sapien commodo faucibus dictum. Sit amet bibendum cras nunc blandit feugiat.
             </Text>
        </div>
  );
}

export default GiftMessage;
